import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { FormattedMessage } from "react-intl";
import { AudienceButton } from "@/components/AudienceButton";
import { useAudienceStore } from "@/lib/stores/audienceStore";
import type { AudienceAgeRange } from "@/lib/types/audience";
import { AuthHeader } from "@/components/AuthHeader";
import { AuthFormCard } from "@/components/AuthFormCard";
import { AuthBackButton } from "@/components/AuthBackButton";
import ageImage from "@/assets/exercise-background-photos/age.png";

const audienceOptions: Array<{
  ageRange: AudienceAgeRange;
  titleId: string;
  descriptionId: string;
}> = [
  {
    ageRange: "under-18",
    titleId: "audience.children.title",
    descriptionId: "audience.children.description",
  },
  {
    ageRange: "18+",
    titleId: "audience.adults.title",
    descriptionId: "audience.adults.description",
  },
];

export const Route = createFileRoute("/audience")({
  component: AudienceSelector,
});

function AudienceSelector() {
  const navigate = useNavigate();
  const setFromAgeRange = useAudienceStore((state) => state.setFromAgeRange);

  const handleSelect = (ageRange: AudienceAgeRange) => {
    setFromAgeRange(ageRange);
    navigate({ to: "/app" });
  };

  return (
    <div className="flex min-h-screen flex-col relative">
      <AuthHeader
        image={ageImage}
        imageAlt="Select Age"
        title={<FormattedMessage id="audience.heading" />}
        subtitle={<FormattedMessage id="audience.subtitle" />}
      />

      <AuthFormCard>
        <AuthBackButton onClick={() => navigate({ to: "/path" })} />

        <div className="flex flex-col gap-4">
          {audienceOptions.map((option) => (
            <AudienceButton
              key={option.ageRange}
              titleId={option.titleId}
              ageRange={option.ageRange}
              onClick={() => handleSelect(option.ageRange)}
            />
          ))}
        </div>
      </AuthFormCard>
    </div>
  );
}
